<template>
  <div class="create-post-drawer"
       v-if="drawer">
    <el-drawer :title="setTitlt"
               :visible.sync="drawer"
               :wrapperClosable="false"
               :close-on-press-escape="false"
               direction="rtl"
               @close="colseDrawer">
      <div class="base">
        <el-form ref="form"
                 :model="form"
                 :inline="true"
                 :rules="rules"
                 label-width="80px"
                 size="mini"
                 v-enterToNext="true">
          <el-form-item label="公司名称"
                        prop="companyid">
            <el-select v-model="form.companyid"
                       placeholder="请选择公司"
                       ref="companyName"
                       filterable
                       :disabled="disabled"
                       class="company"
                       @change="selectCompany">
              <el-option v-for="item in companyList"
                         :key="item.id"
                         :label="item.customerName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="职位名称"
                        prop="position">
            <el-input v-model="form.position"
                      maxlength="20"
                      placeholder="请输入职位名称"></el-input>
          </el-form-item>

          <el-form-item label="职位类型"
                        prop="positionTypeId">
            <el-select v-model="form.positionTypeId"
                       placeholder="职位类型"
                       class="company"
                       style="width: 76%">
              <el-option v-for="item in positionList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <span style="
                text-decoration: underline;
                cursor: pointer;
                color: #409eff;
                margin-left: 8px;
              "
                  @click="addCategoryDrawerShow = true">
              新增
            </span>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="form.sort"
                             :precision="0"></el-input-number>
          </el-form-item>
          <el-row>
            <el-form-item label="人社及保险标准岗位名称"
                          prop="position"
                          label-width="180px"
                          style="width: 520px"
                          class="standardName">
              <el-input readonly
                        v-if="form.standardName"
                        style="margin-right: 15px; width: 200px"
                        v-model="form.standardName"></el-input>
              <el-button size="mini"
                         type="primary"
                         round
                         @click="AImate">AI一键智能匹配</el-button>
            </el-form-item>
          </el-row>
          <el-form-item label="薪资类型"
                        prop="remunerationType">
            <el-select v-model="form.remunerationType"
                       placeholder="请选择薪资类型"
                       clearable
                       @change="$set(form, 'remunerationLevel', '');$forceUpdate()">
              <el-option label="日薪"
                         :value="1"> </el-option>
              <el-option label="周薪"
                         :value="2"> </el-option>
              <el-option label="月薪"
                         :value="3"> </el-option>
              <el-option label="小时工资"
                         :value="4"> </el-option>
              <el-option label="计件工资"
                         :value="5"> </el-option>
            </el-select>
            <!-- <el-radio-group v-model="form.remunerationType">
              <el-radio :label="1">时薪</el-radio>
              <el-radio :label="2">月薪</el-radio>
            </el-radio-group> -->
          </el-form-item>
          <el-form-item label="对外发布"
                        class="form-item-block">
            <el-checkbox v-model="form.isRelease">是</el-checkbox><span class="tip">（注：将同步在小程序和相应平台发布招聘信息）</span>
          </el-form-item>
          <el-divider content-position="center">工资计算组成模块</el-divider>
          <div class="priceSetting">
            <el-form-item label="工厂结算"
                          prop="wages1">
              <el-input v-model="form.wages1"
                        placeholder="请输入工厂结算"
                        maxlength="30"
                        style="width:50%">
                <template slot="append">{{remunerationTypeJudge()}}</template></el-input> <span class="tip">注：工厂给人资公司的价格</span> </el-form-item>

            <el-form-item label="公司报价"
                          prop="wages2">
              <el-input v-model="form.wages2"
                        placeholder="请输入公司报价"
                        maxlength="30"
                        style="width: 50%">
                <template slot="append">{{remunerationTypeJudge()}}</template></el-input><span class="tip"> 注：人资公司对外的价格</span></el-form-item>

            <el-form-item label="员工工资"
                          prop="wages3">
              <el-input v-model="form.wages3"
                        placeholder="请输入员工工资"
                        maxlength="30"
                        style="width: 50%">
                <template slot="append">{{remunerationTypeJudge()}}</template></el-input><span class="tip"> 注：给到员工的价格</span></el-form-item>
            <el-form-item label="工头佣金">
              <el-input v-model="form.commission"
                        placeholder="请输入工头佣金"
                        maxlength="30"
                        style="width: 50%">
                <template slot="append">{{remunerationTypeJudge()}}</template></el-input><span class="tip"> 注：给到工头的价格</span> </el-form-item>
            <el-form-item label="员工奖金">
              <el-input v-model="form.bonus"
                        placeholder="请输入员工奖金"
                        maxlength="30"
                        style="width: 50%">
                <template slot="append">元</template></el-input></el-form-item>

            <el-form-item label="员工扣除">
              <el-input v-model="form.deductMoney"
                        placeholder="请输入扣除项"
                        maxlength="30"
                        style="width: 50%">
                <template slot="append">元</template></el-input></el-form-item>
            <div class="tip bpttpmTip"> 说明：<div>
                <p>（1）公司报价=员工工资+工头佣金</p>
                <p>（2）工厂结算=公司报价+利润 </p>
                <p>（3）员工实际收入=员工工资+员工奖金-员工扣除</p>
              </div>
            </div>
          </div>

          <div v-show="form.isRelease"
               class="foreign">
            <el-form-item label="时薪范围"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 4">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入时薪范围"
                        maxlength="30"
                        style="width: 60%">
                <template slot="append">元/小时</template></el-input></el-form-item>
            <el-form-item label="日收入"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 1">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入日收入范围"
                        maxlength="30"
                        style="width: 60%">
                <template slot="append">元</template></el-input></el-form-item>
            <el-form-item label="月收入"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 3">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入月收入范围"
                        maxlength="30"
                        style="width: 60%">
                <template slot="append">元</template></el-input></el-form-item>
            <el-form-item label="周收入"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 2">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入周收入范围"
                        maxlength="30"
                        style="width: 60%">
                <template slot="append">元</template></el-input></el-form-item>
            <el-form-item label="单件收入"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 5">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入单件收入"
                        maxlength="30"
                        style="width: 60%">
                <template slot="append">元</template></el-input></el-form-item>
            <el-form-item label="招聘状态"
                          prop="state">
              <el-radio-group v-model="form.state"
                              style="width: 280px">
                <el-radio :label="1">未发布</el-radio>
                <el-radio :label="2">招聘中</el-radio>
                <el-radio :label="3">停止招聘</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="福利标签">
              <el-input id="input1"
                        v-model="form.label"
                        maxlength="30"
                        placeholder="如：包吃，包住，厂车等，多个标签用逗号隔开"></el-input>
            </el-form-item>

            <el-form-item label="招聘人数">
              <el-input-number v-model="form.num"
                               @change="handleNumChange"
                               :min="1"
                               label="描述文字"></el-input-number>
            </el-form-item>

            <el-form-item label="性别要求">
              <el-select v-model="form.sex"
                         placeholder="请选择性别要求"
                         clearable>
                <el-option label="男"
                           value="男"> </el-option>
                <el-option label="女"
                           value="女"> </el-option>
                <el-option label="无要求"
                           value="无要求"> </el-option>
              </el-select>
              <!-- <el-input v-model="form.sex" maxlength="30"> </el-input> -->
            </el-form-item>
            <el-form-item label="年龄要求"
                          prop="age">
              <div style="width: 90%; display: inline-block">
                <input-number-range :precision="0"
                                    v-model="form.age"></input-number-range>
              </div>
              岁
            </el-form-item>
            <div style="overflow: hidden">

              <el-col :span="24">
                <el-form-item label="职位描述"
                              class="form-item-block">
                  <vue-ueditor-wrap v-if="form.desc"
                                    v-model="form.desc"
                                    :config="myConfig"></vue-ueditor-wrap>
                  <el-input v-else
                            type="textarea"
                            :rows="2"
                            resize="none"
                            placeholder="请输入职位描述"
                            v-model="form.desc">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="职位要求"
                              class="form-item-block">
                  <vue-ueditor-wrap v-if="form.request"
                                    v-model="form.request"
                                    :config="myConfig"></vue-ueditor-wrap>
                  <el-input v-else
                            type="textarea"
                            :rows="2"
                            resize="none"
                            placeholder="请输入职位要求"
                            v-model="form.request">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="福利待遇"
                              class="form-item-block">
                  <vue-ueditor-wrap v-if="form.weal"
                                    v-model="form.weal"
                                    :config="myConfig"></vue-ueditor-wrap>
                  <el-input v-else
                            type="textarea"
                            :rows="2"
                            resize="none"
                            placeholder="请输入福利待遇"
                            v-model="form.weal">
                  </el-input>
                </el-form-item>
              </el-col>
            </div>
          </div>
        </el-form>
      </div>
      <div class="rightPadding"></div>
      <div class="submit-bar">
        <el-button @click="
            () => {
              colseDrawer();
            }
          ">取 消</el-button>
        <el-button type="primary"
                   :loading="submitLoading"
                   @click="onSubmit('form')">保 存</el-button>
      </div>
    </el-drawer>
    <el-dialog title="新增职位类型"
               :visible.sync="addCategoryDrawerShow"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="500px"
               class="colleague-dialog"
               @close="resetForm">
      <el-form ref="CategoryForm"
               :model="CategoryForm"
               :rules="rules"
               label-width="80px">
        <el-form-item label="类别名称"
                      prop="name">
          <el-input v-model="CategoryForm.name"></el-input>
        </el-form-item>

        <el-form-item label="排序"
                      class="number-footer">
          <el-input-number v-model="CategoryForm.sort"
                           :precision="0"></el-input-number>
        </el-form-item>

        <!-- <el-form-item label="是否管理员">
          <el-switch v-model="form.isManage"></el-switch>
        </el-form-item> -->
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              resetForm();
              addCategoryDrawerShow = false;
            }
          ">取 消</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="addCategory('CategoryForm')">确 定</el-button>
      </span>
    </el-dialog>
    <jobMacting :visible="jobMactingVisible"
                @close="(jobMactingVisible = false), (items = [])"
                :posName="form.position"
                type="1"
                :industry="industry"
                @enter="enter"></jobMacting>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import InputNumberRange from "../../components/InputNumberRange.vue";
import jobMacting from "@/components/jobMatching";

export default {
  components: {
    VueUeditorWrap,
    InputNumberRange,
    jobMacting,
  },
  props: {
    users: Array,
    drawerShow: Boolean,
    postInfo: Object,
    operation: String,
    companyId: String,
    cityList: Array,
  },
  data () {
    let validateage = (rule, value, callback) => {
      if (value == undefined) {
        callback();
        return;
      }
      if (value[0] == null && value[1] == null) {
        callback();
      }
      if (!value[0] || !value[1]) {
        callback(new Error("请输入完整"));
      } else {
        callback();
      }
    };
    return {
      myConfig: {
        // 设置编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 280,
        // 初始容器宽度
        initialFrameWidth: "100%",

        // UEditor 是文件的存放路径，
        UEDITOR_HOME_URL: "/Ueditor/",
      },
      value: "",

      CategoryForm: {},
      submitLoading: false,
      drawer: false,
      addCategoryDrawerShow: false,
      postStateList: [],
      salaryLevel: [],
      form: {
        state: 1,
        num: 1,
        participant: [],
        participantName: [],
        remunerationType: 2,
        isRelease: false,
      },
      rules: {
        name: [{ required: true, message: "请输入类别名称", trigger: "blur" }],
        companyid: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        position: [
          { required: true, message: "请输入职位名称", trigger: "blur" },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
        ],
        wages1: [{ required: true, message: "请输入工厂结算", trigger: "blur" }],
        wages2: [{ required: true, message: "请输入公司报价", trigger: "blur" }],
        wages3: [{ required: true, message: "请输入员工工资", trigger: "blur" }],
        num: [{ required: true, message: "请输入招聘人数", trigger: "blur" }],
        remunerationLevel: [
          { required: true, message: "请输入工资范围", trigger: "blur" },
        ],
        remunerationType: [
          {
            required: true,
            message: "请选择薪资类型",
            trigger: ["blur", "change"],
          },
        ],
        maxNum: [
          {
            required: true,
            message: "请输入工资范围",
            trigger: ["blur"],
          },
        ],
        positionTypeId: [
          {
            required: true,
            message: "请选择职位类型",
            trigger: ["blur", "change"],
          },
        ],
        HourlyWage: [
          { required: true, message: "请输入时薪范围", trigger: "blur" },
        ],
        age: [{ validator: validateage, trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别要求", trigger: "blur" }],
        desc: [
          {
            required: true,
            message: "请输入职位描述",
            trigger: ["blur", "change"],
          },
        ],
        request: [
          {
            required: true,
            message: "请输入职位要求",
            trigger: ["blur", "change"],
          },
        ],
        weal: [
          {
            required: true,
            message: "请输入福利待遇",
            trigger: ["blur", "change"],
          },
        ],
      },
      jobNatureList: [],
      demandTypeList: [],
      postId: "",
      disabled: false,
      companyList: [],
      workExperience: [],
      positionList: [],
      jobMactingVisible: false,
      industry: "",
    };
  },
  mounted () { },
  computed: {
    setTitlt () {
      return this.operation === "edit" ? "修改职位信息" : "新增职位";
    },
  },
  methods: {
    //薪资类型的判断
    remunerationTypeJudge () {
      if (this.form.remunerationType) {
        switch (this.form.remunerationType) {
          case 1:
            return '元/日';
          case 2:
            return '元/周';
          case 3:
            return '元/月';
          case 4:
            return '元/时';
          case 5:
            return '元/件';
          default:
            return '元';
        }
      }
      else {
        return '元';
      }
    },
    // 同步标准职位
    enter (value, name) {
      this.form.standardName = value.standardName;
      this.form.standardRank = value.standardRank;
      this.form.occupationCode = value.occupationCode;
      this.$set(this.form, "position", name);
      // console.log(value);
    },
    selectCompany () {
      this.companyList.forEach((item) => {
        if (item.id == this.form.companyid) {
          this.industry = item.industry;
          console.log(this.industry);
        }
      });
    },
    //匹配标准职位和职级
    AImate () {
      if (!this.form.position || !this.form.companyid) {
        this.$message.warning("请选择公司和填写职位名称");
        return;
      }
      if (this.form.companyid && !this.industry) {
        this.$message.warning("请前往企业\客户完善该公司行业类别");
        return;
      }
      this.jobMactingVisible = true;
    },
    addCategory (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;

          let sendData = {
            name: this.CategoryForm.name,
            sort: this.CategoryForm.sort,
          };
          this.$api.posts
            .PositionTypeEdit(JSON.stringify(sendData))
            .then((res) => {
              if (res.error == false) {
                this.getPositionList();
                this.addCategoryDrawerShow = false;
                this.$message.success("保存成功");
                this.submitLoading = false;
              }
            });
        } else {
          //就像用户提示发生错误的消息
        }
      });
    },
    handleChange (value) { },
    colseDrawer () {
      this.$refs["form"].resetFields();
      this.$emit("colseDrawer");
    },
    handleNumChange (val) {
      this.form.num = val;
    },
    resetForm () {
      this.CategoryForm = {};
      this.$refs.CategoryForm.clearValidate();
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");
          return;
        }
        this.submitLoading = true;
        let sendData = {
          CustomerId: this.form.companyid,
          CustomerName: this.$refs.companyName.selected.label,
          positionName: this.form.position,
          jobDescribe: this.form.desc,
          jobCategory: this.form.jobNature,
          request: this.form.request,
          weal: this.form.weal,
          label: this.form.label,
          recruitingNum: this.form.num,
          remunerationLevel: this.form.remunerationLevel,
          HourlyWage:
            this.form.remunerationType == 1 ? this.form.HourlyWage : "",
          sex: this.form.sex,
          state: this.form.state,
          age: this.form.age && this.form.age.toString(),
          sort: this.form.sort ? this.form.sort : "",
          positionTypeId: this.form.positionTypeId,
          remunerationType: this.form.remunerationType,
          standardName: this.form.standardName,
          standardRank: this.form.standardRank,
          occupationCode: this.form.occupationCode,
          wages1: this.form.wages1,
          wages2: this.form.wages2,
          wages3: this.form.wages3,
          commission: this.form.commission,
          bonus: this.form.bonus,
          deductMoney: this.form.deductMoney,
          isRelease: this.form.isRelease
        };

        if (this.operation === "edit") {
          sendData.id = this.postId;
        }
        this.$api.posts.increasePosts(sendData).then((res) => {
          this.colseDrawer();
          this.$refs[formName].resetFields();
          if (res.error === false) {
            this.$message.success("保存职位信息成功");
            this.$emit("refreshData");
          } else {
            this.$message.error("保存职位信息失败");
          }
          this.submitLoading = false;
          this.postId = "";
        });
      });
    },
    turnNum (nums) {
      if (nums == ",") {
        return;
      }
      return nums.map(Number);
    },
    fillFormData (obj) {
      console.log(obj);
      this.postId = obj.id;
      this.$set(this, 'form', obj)
      this.$set(this.form, "companyid", obj.customerId);
      this.$set(this.form, "companyId", obj.customerId);
      this.$set(this.form, "position", obj.positionName);
      this.$set(this.form, "department", obj.department);
      this.$set(this.form, "num", obj.recruitingNum);
      this.$set(this.form, "startTime", obj.putForwardTime);
      this.$set(this.form, "endTime", obj.inductionTIme);
      this.$set(this.form, "jobNature", obj.jobCategory);
      this.$set(this.form, "demandType", obj.demandType);
      this.$set(this.form, "sex", obj.sex);
      this.$set(this.form, "positionTypeId", obj.positionTypeId);
      this.$set(this.form, "city", obj.workCity && obj.workCity.split(","));
      this.$set(this.form, "isUrgency", obj.CriticalSituation);
      this.$set(this.form, "principalMan", obj.PrincipalId);
      this.$set(this.form, "age", obj.age && this.turnNum(obj.age.split(",")));
      this.$set(this.form, "HourlyWage", obj.hourlyWage);
      this.$set(this.form, "remunerationLevel", obj.remunerationLevel);
      this.$set(this.form, "remunerationType", Number(obj.remunerationType));
      this.$set(this.form, "weal", obj.weal);
      this.$set(this.form, "request", obj.request);
      this.$set(this.form, "sort", obj.sort);
      this.$set(this.form, "state", obj.state);
      this.$set(this.form, "label", obj.label);
      this.$set(this.form, "desc", obj.jobDescribe);
      this.$set(this.form, "remark", obj.Remark);
      this.$set(this.form, "askForEducation", obj.AskForEducation);
      this.$set(this.form, "standardName", obj.standardName);
      this.$set(this.form, "standardRank", obj.standardRank);
      this.$set(this.form, "occupationCode", obj.occupationCode);
      this.$set(this.form, "occupationCode", obj.occupationCode);
      this.$set(this.form, "occupationCode", obj.occupationCode);
      this.$set(this.form, "occupationCode", obj.occupationCode);
      this.$set(this.form, "isRelease", obj.isRelease);

    },

    //获取公司列表
    getCompanyList () {
      this.$api.customer.getAllCustomerList().then((res) => {

        if (res.error === false) {
          this.companyList = res.data;
          // if (this.companyId) {
          this.selectCompany();
          // }
        }
      });
    },
    // 获取职位类型
    getPositionList () {
      this.$api.posts.PositionTypePage().then((res) => {

        if (res.error === false) {
          this.positionList = res.data.data;
        }
      });
    },
  },
  watch: {
    drawerShow (val) {
      this.drawer = val;
      if (val) {
        this.getCompanyList();
        this.getPositionList();
      }
      if (this.drawer == false) {
        console.log(1);
        this.form = {
          // 当弹窗关闭时 强制初始化表单
          num: 1,
          state: 1,
          participant: [],
          participantName: [],
        };
        this.$forceUpdate();
        this.postId = "";
        if (val) {
          this.$nextTick(() => {
            this.$refs["form"].clearValidate();
          });
          return;
        }
      }
      console.log(this.operation);
      if (this.operation == "edit" && this.drawer) {
        this.fillFormData(this.postInfo);
      }
      if (this.operation == "add") {
        this.$set(this.form, "age", [null, null]);
        this.form.remunerationType = "";
      }
      if (this.companyId) {
        this.$set(this.form, "companyid", this.companyId);

        this.disabled = true;
      }
    },
  },
};
</script>

<style lang="less">
#input1 {
  width: 300px;
}
.create-post-drawer {
  .el-drawer {
    width: 78% !important;
    min-width: 1150px;

    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      // display: flex;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .base {
    width: 80%;
    float: left;
    padding: 17px 50px 60px 50px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;

    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 56%;
      }

      .el-select {
        width: 100%;
      }
    }
    .standardName {
      .el-form-item__content {
        width: auto;
      }
    }
    .minNum {
      .el-form-item__content {
        width: 50% !important;
      }
    }
    .code-input {
      .el-form-item__content {
        width: calc(85% - 55px);
      }
    }
    .form-item-block {
      width: 100%;
      .el-form-item__content {
        width: 90%;
      }
    }
    .foreign {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #dcdfe6;
    }
  }
  .tip {
    font-size: 12px;
    color: #909399;
  }
  .priceSetting {
    .el-form-item__content {
      width: 70% !important;
    }

    .bpttpmTip {
      display: flex;
      p {
        line-height: 1.6;
      }
    }
  }
  .el-divider__text.is-center {
    color: #66b1ff;
  }
  .block {
    display: block;
    .el-form-item__content {
      width: calc(100% - 80px);
    }
  }
}
// .post-form {
//   .el-input {
//     min-width: 280px;
//     max-width: 350px;
//   }
//   .el-input-number {
//     .el-input {
//       min-width: auto;
//     }
//   }
// }
.submit-bar {
  position: absolute;
  z-index: 99999999;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
  .el-button {
    padding: 8px 20px;
  }
}
</style>
